import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";

const serif = { fontFamily: "'Cormorant Garamond','EB Garamond',Georgia,serif" };
const track = (name) => { try { window.gtag && window.gtag("event", name); } catch (_) {} };

// Shared central "create your free My StoicOs" block (homepage + Agora).
export default function MyStoicOsBlock({ trackEvent = "home_entry_path_selected" }) {
  const { t } = useT();
  return (
    <section id="begin" className="max-w-3xl mx-auto px-6 md:px-10 pt-24 md:pt-36" data-testid="home-mystoicos-block">
      <div className="border border-white/10 bg-[#0b0b0b] p-8 md:p-12">
        <h2 style={serif} className="text-3xl md:text-4xl text-bone">{t("home.my.title")}</h2>
        <p className="mt-5 text-bone/75 font-light leading-relaxed">{t("home.my.intro")}</p>
        <p className="mt-6 text-bone/75 font-light">{t("home.my.access")}</p>
        <ul className="mt-3 space-y-2 text-bone/70 font-light list-none">
          {["b1", "b2", "b3", "b4", "b5", "b6", "b7", "b8"].map((b) => (
            <li key={b} className="pl-5 relative"><span className="absolute left-0 text-gold" aria-hidden="true">—</span>{t(`home.my.${b}`)}</li>
          ))}
        </ul>
        <p className="mt-6 text-bone/60 font-light leading-relaxed text-sm">{t("home.my.secure")}</p>
        <Link to="/my-stoicos" data-testid="mystoicos-create-btn" onClick={() => track(trackEvent)}
          className="mt-8 inline-block min-h-[48px] px-7 py-3.5 bg-gold text-ink text-[11px] tracking-[0.24em] uppercase font-semibold leading-relaxed hover:bg-gold/90 transition-colors">
          {t("home.my.cta")}
        </Link>
      </div>
    </section>
  );
}
